import React, { useCallback, useState, useEffect, useMemo } from "react";
import { Form, Row, Col, Tooltip, Checkbox, Select } from "antd";
import { useIntl } from "react-intl";

import LoadError from "../../app/generic/loadError";
import { handleError } from "../../../modules/errorLogger.ts";
import { createQueryString } from "../../../modules/crudOperations";
import { get, checkHttpStatus } from "../../../modules/httpFunctions";

const { Item } = Form;
const { Option } = Select;

function PersonalDepot({
  form,
  detail,
  depots,
  inputId,
  product,
  loadDepots,
  addressType,
  personalDepotId,
  selectedCountry,
}) {
  const intl = useIntl();
  const { getFieldDecorator } = form;
  const pickup = addressType === "PC";
  const type = pickup
    ? intl.formatMessage({
        id: "address.self.pickup",
        defaultMessage: "podej",
      })
    : intl.formatMessage({
        id: "address.self.delivery",
        defaultMessage: "odběr",
      });

  const filteredDepots = useMemo(() => {
    return (pickup &&
      product &&
      (product.code === "ECI" ||
        product.code === "SPI" ||
        product.code === "ERI" ||
        product.code === "PPI")) ||
      !depots ||
      depots === "e"
      ? depots
      : depots.filter((d) => d.address.country.code === "CZ");
  }, [depots, pickup, product]);

  const [personal, setPersonal] = useState();
  useEffect(() => {
    if (personalDepotId) {
      setPersonal(personalDepotId > 0);
      personalDepotId && loadDepots();
    }
  }, [loadDepots, personalDepotId]);

  const [addressDepot, setAddressDepot] = useState();
  const loadRegion = useCallback(() => {
    const zipCode = form.getFieldValue(`zipCode${inputId}`);
    zipCode &&
      get(
        `region${createQueryString({
          zipCode,
          product: product && product.code,
          country: selectedCountry && selectedCountry.code,
        })}`
      )
        .then((r) => {
          setAddressDepot(checkHttpStatus(r) ? r.terminal : undefined);
        })
        .catch((err) => {
          setAddressDepot();
          handleError(err);
        });
  }, [form, inputId, product, selectedCountry]);

  const onPersonalChange = useCallback(
    (e) => {
      setPersonal(e.target.checked);
      if (e.target.checked) {
        loadDepots();
        loadRegion();
      }
    },
    [loadRegion, loadDepots, setPersonal]
  );

  return (
    <Row>
      <Col xxl={{ span: 5, offset: 4 }} sm={{ span: 6, offset: 5 }}>
        <Item wrapperCol={{ span: 24 }} className="address-no-bottom">
          {getFieldDecorator(`personal${inputId}`)(
            <Checkbox
              disabled={detail}
              checked={personal}
              onChange={onPersonalChange}
            >
              {intl.formatMessage(
                {
                  id: "address.self.type",
                  defaultMessage: "Osobní {type} na depu",
                },
                { type }
              )}
            </Checkbox>
          )}
        </Item>
      </Col>
      <Col xxl={{ span: 7 }} sm={{ span: 10 }}>
        {personal && filteredDepots ? (
          filteredDepots !== "e" ? (
            <Item
              label={intl.formatMessage({
                id: "address.self.depot",
                defaultMessage: "Depo",
              })}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}
              className="address-no-bottom"
            >
              {getFieldDecorator(`personalDepotId${inputId}`, {
                initialValue:
                  (addressDepot &&
                    filteredDepots.some((d) => d.code === addressDepot) &&
                    filteredDepots.find((d) => d.code === addressDepot).id) ||
                  personalDepotId ||
                  filteredDepots[0].id,
                rules: [
                  {
                    required: personal,
                    message: intl.formatMessage(
                      {
                        id: "address.self.emptyDepot",
                        defaultMessage:
                          "Vyberte prosím depo DHL pro osobní {type}!",
                      },
                      { type }
                    ),
                  },
                ],
              })(
                <Select allowClear disabled={detail}>
                  {filteredDepots.map((d, i) => (
                    <Option key={i} value={d.id}>
                      <Tooltip title={d.addressInfo}>
                        {d.code} {">"} {d.name}
                      </Tooltip>
                    </Option>
                  ))}
                </Select>
              )}
            </Item>
          ) : (
            <LoadError
              message={intl.formatMessage({
                id: "address.self.error",
                defaultMessage: "Při načítání dep nastala chyba!",
              })}
              onClick={loadDepots}
            />
          )
        ) : null}
      </Col>
    </Row>
  );
}

export default PersonalDepot;
